import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge reads our 17 ramp utilities (`text-h1`, `text-mono`, ...) as colour
// classes, so cn("text-h1", "text-foreground") returns only "text-foreground" and the
// type ramp silently disappears. Teach it they are font-size steps instead.
const RAMP = [
  "display-xl",
  "display",
  "h1",
  "h2",
  "h3",
  "h4",
  "body-lg",
  "body",
  "label",
  "body-sm",
  "caption",
  "overline",
  "mono-lg",
  "mono",
  "mono-sm",
  "signature",
  "attestation",
];

const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: RAMP }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
